import { connect } from 'react-redux';
import AdminTax from './AdminTax.component';

import {
  taxCreate,
  taxUpdate,
  taxList,
} from '../../../redux/actions/tax.actions';

const mapStateToProps = (state) => ({
  tax_setting: state.common.tax,
});

const mapDispatchToProps = {
  taxCreate,
  taxUpdate,
  taxList,
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminTax);
